import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SweepOptionsService = /** @class */ (function () {
    function SweepOptionsService(http) {
        this.http = http;
        this.defaultApiUrl = '/api/secure/securities/v1/securities?securitycategory=SWEEPOPTION';
    }
    /**
     * Sweeop Option by sweeop option symbol
     * @param symbol sweeop option symbol
     * @returns sweep option
     */
    SweepOptionsService.prototype.getSweepOptionBySymbol = function (symbol) {
        var _this = this;
        return this.getSweepOptions().pipe(map(function (sweepOptions) {
            return _this.prepareSweepOption(_this.filterSweepOptionsByCode(symbol, sweepOptions ? sweepOptions : []), symbol);
        }));
    };
    /**
     * Sweeop Options
     * @returns List of sweep option
     */
    SweepOptionsService.prototype.getSweepOptions = function () {
        if (this.sweepOptionObservable) {
            return this.sweepOptionObservable;
        }
        this.sweepOptionObservable = this.http.get(this.defaultApiUrl).pipe(catchError(function (error) {
            return of(null);
        }), shareReplay(1));
        return this.sweepOptionObservable;
    };
    SweepOptionsService.prototype.filterSweepOptionsByCode = function (symbol, sweepOptions) {
        var foundOptions = sweepOptions.filter(function (sweepOption) {
            return sweepOption && sweepOption.symbol === symbol;
        });
        if (foundOptions && foundOptions.length > 0) {
            return foundOptions[0];
        }
        return null;
    };
    SweepOptionsService.prototype.prepareSweepOption = function (rawSweepOption, symbol) {
        if (!rawSweepOption || !rawSweepOption.yield || rawSweepOption.yield.length === 0) {
            return null;
        }
        var yields = this.getYieldsBySymbol(rawSweepOption.yield, symbol);
        if (!yields) {
            return null;
        }
        return {
            symbol: rawSweepOption.symbol,
            title: rawSweepOption.title,
            description: rawSweepOption.description,
            yield: yields
        };
    };
    SweepOptionsService.prototype.getYieldsBySymbol = function (rawYields, symbol) {
        var yields = rawYields.filter(function (rawYield) {
            if (!rawYield) {
                return false;
            }
            if (rawYield.preferred) {
                return true;
            }
            return ((symbol === 'FDUXX' || symbol === 'PMZXX') &&
                ((rawYield.duration === '365' || rawYield.duration === '7') && rawYield.unit === 'day'));
        }).map(function (rawYield) {
            return {
                value: rawYield.value,
                duration: rawYield.duration,
                durationUnit: rawYield.unit,
                asOfDate: rawYield.asOfDate
            };
        });
        if (yields && yields.length > 0) {
            return yields;
        }
        return null;
    };
    SweepOptionsService.ngInjectableDef = i0.defineInjectable({ factory: function SweepOptionsService_Factory() { return new SweepOptionsService(i0.inject(i1.HttpClient)); }, token: SweepOptionsService, providedIn: "root" });
    return SweepOptionsService;
}());
export { SweepOptionsService };
